import { useMemo } from "react"

import {
    Layer,
    MapStyles,
    TRAFFIC_LAYER,
    TRAFFIC_SOURCE,
    useMapStateContext,
    useOrderingLayers,
} from "@l2r-front/l2r-map"
import { useNetworksStateContext } from "@l2r-front/l2r-networks"
import { useTheme } from "@l2r-front/l2r-ui"

import { useSpeedingsStateContext } from "../../contexts/SpeedingsContext"
import { getTrafficLayerStyle } from "../../utils/getTrafficConfig"

import { TrafficSource } from "../TrafficSource"

export function TrafficLayer() {

    const { selectedLinearLocations } = useNetworksStateContext()
    const { currentMapStyle } = useMapStateContext()
    const { currentActiveLayer, currentYear } = useSpeedingsStateContext()
    const theme = useTheme()

    const trafficLayerConfig = useMemo(() => {
        const selectedRoad = selectedLinearLocations?.[0].road
        const referentialColor = currentMapStyle === MapStyles.plan ? theme.palette.map.darkReferential
            : theme.palette.map.lightReferential
        return getTrafficLayerStyle(currentActiveLayer, referentialColor, theme, selectedRoad, currentYear)
    }, [currentActiveLayer, currentMapStyle, theme, selectedLinearLocations, currentYear])

    useOrderingLayers([TRAFFIC_LAYER])

    return (
        <TrafficSource
            currentActiveLayer={currentActiveLayer}
            id={TRAFFIC_SOURCE}
            tolerance={.001}
        >
            <Layer
                id={TRAFFIC_LAYER}
                {...trafficLayerConfig}
            />
        </TrafficSource>
    )
}
